import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7e7887b4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "系统介绍", -1);
});

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "系统介绍", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_house = _resolveComponent("house");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_menu_item = _resolveComponent("el-menu-item");

  var _component_el_tooltip = _resolveComponent("el-tooltip");

  var _component_el_sub_menu = _resolveComponent("el-sub-menu");

  var _component_el_menu = _resolveComponent("el-menu");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createBlock(_component_el_scrollbar, {
    style: {
      "background-color": "#304156"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_menu, {
        "active-text-color": "#ffd04b",
        class: "el-menu-vertical-demo",
        "background-color": "#304156",
        "text-color": "#fff",
        collapse: $props.title,
        router: true,
        "default-active": _ctx.$route.path
      }, {
        default: _withCtx(function () {
          return [$props.title ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            class: "box-item",
            effect: "dark",
            content: "系统介绍",
            placement: "right"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_menu_item, {
                index: "/index/home"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_icon, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_house)];
                    }),
                    _: 1
                  }), _hoisted_1];
                }),
                _: 1
              })];
            }),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: "/index/home"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_icon, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_house)];
                }),
                _: 1
              }), _hoisted_2];
            }),
            _: 1
          })), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pages, function (item, index) {
            return _openBlock(), _createBlock(_component_el_sub_menu, {
              index: index + 1 + '',
              key: index
            }, {
              title: _withCtx(function () {
                return [_createVNode(_component_el_icon, {
                  class: _normalizeClass('iconfont ' + item.meta.icon)
                }, null, 8, ["class"]), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)];
              }),
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, function (items, indexs) {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    index: /index/ + item.path + '/' + items.path,
                    key: indexs
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(items.meta.title), 1)];
                    }),
                    _: 2
                  }, 1032, ["index"]);
                }), 128))];
              }),
              _: 2
            }, 1032, ["index"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["collapse", "default-active"])];
    }),
    _: 1
  });
}